import { Tournament_Members_IncomeViewModel } from "models/Player_OrganizerHeaderViewModel"
import { Dispatch } from "redux"
import { EndPoints } from "server/endpoints"
import { fetchApi } from "server/server-utils"
import { GetState } from "store/types/common"
import { OrganizerTournamentAndMembersAndIncomeLoaded } from "store/types/organizer-tournament-members-income-type"
import { OperationTypes, run } from "./operations-logic"

export const loadOrganizerTournamentAndMembersAndIncome = (organizerId: number) => async (dispatch: Dispatch, getState: GetState) => {
  await run(OperationTypes.loadOrganizerTournamentAndMembersAndIncome, organizerId, dispatch, getState, async () => {
    try {
      const model = await fetchApi<Tournament_Members_IncomeViewModel>(EndPoints.Tournament.TournamentAndMembersAndIncome + "?organizerId="+ organizerId, 'GET')
      dispatch(OrganizerTournamentAndMembersAndIncomeLoaded({
        OrganizerTournamentAndMembersAndIncome : model
      }))
    } catch {
      return false
    }
    return true
  })
}